export default {
  slideTypes: [
    'qrcode',
    'youtube',
    'googleSlides',
    'spinnerWheel',
  ],
}
